"use client";

import dynamic from "next/dynamic";

import type { NavSettings } from "@/lib/nav";
import type { SearchEntry } from "@/lib/search";

const FaqDrawer = dynamic(
  () => import("@/components/faq/faq-drawer").then((m) => m.FaqDrawer),
  { ssr: false },
);
const BookingDrawer = dynamic(
  () =>
    import("@/components/layout/booking-drawer").then((m) => m.BookingDrawer),
  { ssr: false },
);
const MenuDialog = dynamic(
  () => import("@/components/layout/menu-dialog").then((m) => m.MenuDialog),
  { ssr: false },
);
const MenuDrawer = dynamic(
  () => import("@/components/layout/menu-drawer").then((m) => m.MenuDrawer),
  { ssr: false },
);
const SearchDialog = dynamic(
  () => import("@/components/search/search-dialog").then((m) => m.SearchDialog),
  { ssr: false },
);

export function LazyFaqDrawer() {
  return <FaqDrawer />;
}

export function LazyBookingDrawer({
  bookingImage,
}: {
  bookingImage?: string | null;
}) {
  return <BookingDrawer bookingImage={bookingImage} />;
}

export function LazyMenuDialog({
  navSettings,
}: {
  navSettings: NavSettings | null;
}) {
  return <MenuDialog navSettings={navSettings} />;
}

export function LazyMenuDrawer({
  navSettings,
}: {
  navSettings: NavSettings | null;
}) {
  return <MenuDrawer navSettings={navSettings} />;
}

export function LazySearchDialog({
  navSettings,
  index,
}: {
  navSettings: NavSettings | null;
  index: SearchEntry[];
}) {
  return <SearchDialog navSettings={navSettings} index={index} />;
}
